import { Box, Button, IconButton, Menu, MenuItem, Pagination, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { menuActive } from 'store/menuSlice'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';
import * as api from '../services/api'
import Loader from 'components/Loader';
import CustomizedModal from 'components/modal/CustomizedModal';
import { useSelector } from 'react-redux';

function CoordinateContact() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const auth = useSelector((state) => state.auth.user_data)
    const [role, setRole] = useState(auth['permission']['group_code'])

    const [search, setSearch] = useState('')
    const [year_, setYear_] = useState(new Date().getFullYear())
    const [optionYear, setOptionYear] = useState([])

    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const [showList, setShowList] = useState([])

    const options = [
        'แก้ไข',
        'ดูข้อมูล'
    ];

    const optionsAdmin = [
        'แก้ไข',
        'ดูข้อมูล',
        'ลบ'
    ];

    const ITEM_HEIGHT = 3;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event, item) => {
        setItemAnchorEl(item)
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [itemAnchorEl, setItemAnchorEl] = useState([])
    const [modalDelete, setModalDelete] = useState(false)

    useEffect(() => {
        dispatch(menuActive('ติดต่อประสานงาน'))
    }, [])

    useEffect(() => {
        findContacts()
    }, [year_, page])

    useEffect(() => {
        setPage(1)
    }, [year_, search])

    const handlePageChange = (event, page) => {
        setPage(page)
    }

    const findContacts = async () => {
        setLoading(true)
        let res = await api.contacts(search, null)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                let sum = res['data']['data'].sort((a, b) => new Date(b.created_date) - new Date(a.created_date));
                setShowList(sum)

                let pagg = res['data']['pagging']
                setPage(pagg['page'])
                setTotalPage(pagg['totalPage'])
            } else if (res['data']['code'] === 999) {
                setShowList([])
                setPage(1)
                setTotalPage(1)
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const deleteContacts = async () => {
        setLoading(true)
        let res = await api.deleteContacts(itemAnchorEl['contact_code'])
        setLoading(false)
        setModalDelete(false)
        if (res) {
            if (res['data']['code'] == '200') {
                //alert(res['data']['message'])
                findContacts()
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }

        const thaiLocale = 'th-TH'
        const formattedDate = date.toLocaleString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`

        return newDate
    }

    const handleClickOption = (e) => {
        let { textContent } = e.target
        if (textContent == 'แก้ไข') {
            navigate('/editCoordinate', { state: { item: itemAnchorEl } })
        } else if (textContent == 'ดูข้อมูล') {
            navigate('/detailsCoordinate', { state: { code: itemAnchorEl['contact_code'] } })
        } else if (textContent == 'ลบ') {
            setModalDelete(true)
        }
        setAnchorEl(null);
    };

    const handleClickSearch = () => {
        findContacts()
    }

    // const handleFilterYear = (e) => {
    //     let { value } = e.target
    //     setYear_(value)
    // }

    return (
        <>
            <Loader loading={loading} />
            {modalDelete ?
                <CustomizedModal
                    onClose={() => { setModalDelete(false) }}
                    apiCall={deleteContacts}
                    confirmMessage={`ต้องการลบ "${itemAnchorEl.contact_topic}" หรือไม่?`}
                    confirmButtonText={`ยืนยัน`}
                />
                : null
            }

            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    fontWeight: 600,
                    color: "#478F96",
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>ติดต่อประสานงาน</Box>
                <Box sx={{
                    "@media (max-width: 800px)": {
                        textAlign: "center",
                    },
                }}>ส่งข้อมูลข่าวสารภายใน ระหว่างหน่วยงานและแอดมินสำนักงานแพทย์</Box>

                <Box sx={{
                    border: '1px solid #478F96',
                    borderRadius: '10px',
                    padding: '20px',
                    display: 'grid',
                    gridGap: '20px'
                }}>
                    <Box>
                        <Box sx={{
                            fontWeight: 600,
                            "@media (max-width: 800px)": {
                                textAlign: "center",
                            },
                        }}>ค้นหาหัวข้อ</Box>
                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            display: 'flex',
                            padding: '5px'
                        }}>
                            <TextField
                                fullWidth
                                variant="standard"
                                sx={{ ...InputCSS }}
                                InputProps={{
                                    disableUnderline: true,
                                }}
                                placeholder="ค้นหาด้วยชื่อ"
                                value={search}
                                onChange={(e) => { setSearch(e.target.value) }}
                            />
                            <Button variant='contained' onClick={() => { handleClickSearch() }}>ค้นหา</Button>
                        </Box>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        "@media (max-width: 800px)": {
                            display: 'grid'
                        },
                    }}>
                        {/* <Select
                            size="small"
                            sx={{ ...SelectCss }}
                            value={year_}
                            onChange={(e) => { handleFilterYear(e) }}
                        >
                            {optionYear.map((i, idx) => (
                                <MenuItem key={idx} value={i['value']}>{i['label']}</MenuItem>
                            ))}
                        </Select> */}
                        <Box></Box>
                        {role === 'G-0010' &&
                            <Button variant='contained' onClick={() => { navigate('/addCoordinate') }}>เพิ่มข้อมูล</Button>
                        }
                    </Box>

                    <Box sx={{
                        overflow: 'auto'
                    }}>
                        <TableContainer sx={{ maxHeight: '700px' }}>
                            <Table sx={{ minWidth: '800px' }}>
                                <TableHead sx={{ backgroundColor: '#C8EBEB' }}>
                                    <TableRow>
                                        <TableCell sx={{ width: '200px' }}>วันที่สร้าง</TableCell>
                                        <TableCell>ชื่อหัวข้อ</TableCell>
                                        <TableCell sx={{ width: '200px' }} align='center'>สถานะ</TableCell>
                                        <TableCell sx={{ width: '100px' }} align='center'>เพิ่มเติม</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {showList.length > 0 ? (
                                        showList.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{convertDate(item['created_date'])}</TableCell>
                                                <TableCell>{item['contact_topic']}</TableCell>
                                                <TableCell align='center'>
                                                    <Button
                                                        variant='contained'
                                                        sx={item['doc_status'] == 'R' ? { backgroundColor: '#C8EBEB', color: '#252641', cursor: 'default' } : { backgroundColor: '#FCFFA0', color: '#252641', cursor: 'default' }}
                                                    >
                                                        {item['doc_status'] == 'R' ? 'มีการตอบกลับแล้ว' : 'ยังไม่มีการตอบกลับ'}
                                                    </Button>
                                                </TableCell>
                                                <TableCell align='center'>
                                                    <>
                                                        <IconButton
                                                            aria-label="more"
                                                            id="long-button"
                                                            aria-controls={open ? 'long-menu' : undefined}
                                                            aria-expanded={open ? 'true' : undefined}
                                                            aria-haspopup="true"
                                                            onClick={(event) => { handleClick(event, item) }}
                                                        >
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                        <Menu
                                                            id="long-menu"
                                                            MenuListProps={{
                                                                'aria-labelledby': 'long-button',
                                                            }}
                                                            anchorEl={anchorEl}
                                                            open={open}
                                                            onClose={handleClose}
                                                            slotProps={{
                                                                paper: {
                                                                    style: {
                                                                        minHeight: ITEM_HEIGHT * 4.5,
                                                                        width: '20ch',
                                                                        boxShadow: '0px 5px 10px rgba(168, 168, 168, 0.1)',
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            {role === 'G-0010' ?
                                                                (optionsAdmin.map((option) => (
                                                                    <MenuItem key={option} onClick={handleClickOption}>
                                                                        <div style={option === 'ลบ' ? { color: '#E06262' } : {}}>{option}</div>
                                                                    </MenuItem>
                                                                )))
                                                                :
                                                                (options.map((option) => (
                                                                    <MenuItem key={option} onClick={handleClickOption}>
                                                                        {option}
                                                                    </MenuItem>
                                                                )))
                                                            }

                                                        </Menu>
                                                    </>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )
                                        :
                                        (
                                            <TableRow>
                                                <TableCell colSpan='10'>
                                                    <Box sx={{ textAlign: 'center' }}>ไม่มีข้อมูล</Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        margin: 2
                    }}>
                        <Box sx={{ width: '100px' }}>
                        </Box>
                        <Stack spacing={2}>
                            <Pagination
                                count={totalPage}
                                page={page}
                                onChange={handlePageChange}
                                shape="rounded"
                                color="primary"
                            />
                        </Stack>
                    </Box>

                </Box>
            </Box>
        </>
    )
}

export default CoordinateContact

const SelectCss = {
    backgroundColor: '#C8EBEB',
    border: 'none',
    '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#C8EBEB',
    },
}

const InputCSS = {
    padding: '5px',
    border: 'none',
    '&.MuiInputBase-root': {
        border: 'none'
    },
    '&.MuiInputBase-root:focus': {

    }
}
